import React, { useState } from 'react'
import HomeContainer from '../Container/HomeContainer2'
import Spinner from '../../Components/Spinner/Spinner'
import EcecResumeContent from './EcecResumeContent'

const EcecSharedResume = (props) => {
  const [user, setUSer] = useState(props.location.data)

  if (user) {
    return (
      <HomeContainer
        isViewAsTeacher={false}
        footer={null}
        isShowWhereby={false}
        isShowPoliceCheckWwcc={true}
        tabEcecResumeActive={true}
        isShared
        user={user}
      >
        <EcecResumeContent user={user} isViewAsTeacher={false} />
      </HomeContainer>
    )
  }
  else return <Spinner />
}

export default EcecSharedResume
